import {Parser} from "binary-parser";
import {MODE} from "./constant";

function toNumber(number) {
  return number.toString();
}
function _atos(array) {
  let newarray = [];
  try {
    for (let i = 0; i < array.length; i++) {
      newarray.push(String.fromCharCode(array[i]));
    }
  } catch (e) {
    throw new Error(e);
  }

  let token = JSON.stringify(newarray.join(''));
  return token.replaceAll('\\u0000', '')
    .replaceAll('\\u0001', '')
    .replaceAll('\"', '' );
}

const subscription_mode = new Parser().uint8('subscription_mode');
export function setResponse(buf, result) {
  switch (subscription_mode.parse(buf)?.subscription_mode) {
    case MODE.LTP:
      return LTP(buf);
    case MODE.Quote:
      return QUOTE(buf);
    case MODE.SnapQuote:
      return SNAP_QUOTE(buf);
    case MODE.Depth:
      return DEPTH(buf);
    default:
      return result;
  }
}
const ltpParser = new Parser()
  .endianness('little')
  .int8('subscription_mode', { formatter: toNumber })
  .int8('exchange_type', { formatter: toNumber })
  .array('token', {
    type: 'uint8',
    length: 25,
    formatter: _atos,
  })
  .int64('sequence_number', { formatter: toNumber })
  .int64('exchange_timestamp', { formatter: toNumber })
  .int32('last_traded_price', { formatter: toNumber });

const quoteParser = new Parser()
  .endianness('little')
  .uint8('subscription_mode', { formatter: toNumber, length: 1 })
  .uint8('exchange_type', { formatter: toNumber, length: 1 })
  .array('token', { type: 'int8', length: 25, formatter: _atos })
  .uint64('sequence_number', { formatter: toNumber, length: 8 })
  .uint64('exchange_timestamp', { formatter: toNumber, length: 8 })
  .uint64('last_traded_price', { formatter: toNumber, length: 8 })
  .int64('last_traded_quantity', { formatter: toNumber, length: 8 })
  .int64('avg_traded_price', { formatter: toNumber, length: 8 })
  .int64('vol_traded', { formatter: toNumber, length: 8 })
  .doublele('total_buy_quantity', { formatter: toNumber, length: 8 })
  .doublele('total_sell_quantity', { formatter: toNumber, length: 8 })
  .int64('open_price_day', { formatter: toNumber, length: 8 })
  .int64('high_price_day', { formatter: toNumber, length: 8 })
  .int64('low_price_day', { formatter: toNumber, length: 8 })
  .int64('close_price', {
    formatter: toNumber,
    length: 8,
  });

function LTP(buf) {
  return ltpParser.parse(buf);
}
function QUOTE(buf) {
  return quoteParser.parse(buf);
}

function SNAP_QUOTE(buf) {
  const bestFiveData = new Parser()
    .endianness('little')
    .int16('flag', { formatter: toNumber, length: 2 })
    .int64('quantity', { formatter: toNumber, length: 8 })
    .int64('price', { formatter: toNumber, length: 8 })
    .int16('no_of_orders', { formatter: toNumber, length: 2 });

  const snapQuote = new Parser()
    .endianness('little')
    .uint8('subscription_mode', { formatter: toNumber, length: 1 })
    .uint8('exchange_type', { formatter: toNumber, length: 1 })
    .array('token', { type: 'int8', length: 25, formatter: _atos })
    .uint64('sequence_number', { formatter: toNumber, length: 8 })
    .uint64('exchange_timestamp', { formatter: toNumber, length: 8 })
    .uint64('last_traded_price', { formatter: toNumber, length: 8 })
    .int64('last_traded_quantity', { formatter: toNumber, length: 8 })
    .int64('avg_traded_price', { formatter: toNumber, length: 8 })
    .int64('vol_traded', { formatter: toNumber, length: 8 })
    .doublele('total_buy_quantity', { formatter: toNumber, length: 8 })
    .doublele('total_sell_quantity', { formatter: toNumber, length: 8 })
    .int64('open_price_day', { formatter: toNumber, length: 8 })
    .int64('high_price_day', { formatter: toNumber, length: 8 })
    .int64('low_price_day', { formatter: toNumber, length: 8 })
    .int64('close_price', {
      formatter: toNumber,
      length: 8,
    })
    .int64('last_traded_timestamp', { formatter: toNumber, length: 8 })
    .int64('open_interest', { formatter: toNumber, length: 8 })
    .doublele('open_interest_change', {
      formatter: toNumber,
      length: 8,
    })
    .array('best_5_buy_data', { type: bestFiveData, lengthInBytes: 100 })
    .array('best_5_sell_data', { type: bestFiveData, lengthInBytes: 100 })
    .int64('upper_circuit', { formatter: toNumber, length: 8 })
    .int64('lower_circuit', { formatter: toNumber, length: 8 })
    .int64('fiftytwo_week_high', {
      formatter: toNumber,
      length: 8,
    })
    .int64('fiftytwo_week_low', { formatter: toNumber, length: 8 });

  // let response = snapQuote.parse(buf);
  return snapQuote.parse(buf);
}

function DEPTH(buf) {
  const depthTwenty = new Parser()
    .endianness("little")
    .int32("quantity", { formatter: toNumber, length: 4 })
    .int32("price", { formatter: toNumber, length: 4 })
    .int16("no_of_orders", { formatter: toNumber, length: 2 });

  const depth = new Parser()
    .endianness("little")
    .uint8("subscription_mode", { formatter: toNumber, length: 1 })
    .uint8("exchange_type", { formatter: toNumber, length: 1 })
    .array("token", { type: "int8", length: 25, formatter: _atos })
    .uint64("exchange_timestamp", { formatter: toNumber, length: 8 })
    .int64("packet_received_time", { formatter: toNumber, length: 8 })
    .array("depth_twenty_buy_data", { type: depthTwenty, lengthInBytes: 200 })
    .array("depth_twenty_sell_data", {
      type: depthTwenty,
      lengthInBytes: 200,
    });

  return depth.parse(buf);
}